import classes from '../Pages.module.css';
import {Row,Col, Tabs, Skeleton, message} from 'antd';
import axios from 'axios';
import DataContext from '../../../Context/dataContext';
import { useState, useEffect, useContext} from 'react';
import BasicLeaveDetails from './BasicLeaveDetails';
import LeaveNormDetails from './LeaveNormDetails';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SyncLoader from "react-spinners/SyncLoader";

const { TabPane } = Tabs;

const LeaveNormsView = (props) => {
    const { id } = useParams();
    const employeeData = useContext(DataContext)
    const history = useNavigate();

    const [editMode, setEditMode] = useState(true)
    const [loading, setLoading] = useState(false)
    const [allData, setAllData] = useState(null)
    const [ad, setAD] = useState(null)
    const [storeData, setStoreData] = useState(null)

    useEffect(() => {

        setAllData(null)
        setStoreData(null)
        setAD(null)
        setLoading(false)
        axios
        .get(employeeData.URL + '/api/v1/norms/leave-norms/additional-data',{
            withCredentials: true
        })
        .then((response) => {

            console.log(response);
            setAD(ad => {
                let newad = response.data.data
                return({
                    ...newad,
                    GENDER: {
                        fields: [{name: "KEY"},{name: "VALUE"}],
                        rows: [{KEY: "M", VALUE: "Male"},{KEY: "F", VALUE: "Female"}]
                    },
                    YESNO: {
                        fields: [{name: "KEY"},{name: "VALUE"}],
                        rows: [{KEY: "Y", VALUE: "Yes"},{KEY: "N", VALUE: "No"}]
                    },
                });
            })
        })
        .catch((error) => {
            console.log(error);
        })

        axios
            .get(employeeData.URL + '/api/v1/norms/leave-norms/' + id,{
                withCredentials: true
            })
            .then((response) => {

                console.log(response);
                setAllData(allData => {
                    const newData = response.data.data
                    return newData
                })

                setStoreData(allData => {
                    const newData = response.data.data
                    return newData
                })

            })
            .catch((error) => {
                console.log(error);
            })
        
            
    }, [])

    const handleSave = (event) => {

        var formv = true
        let count = 0;
        allData.details.rows.forEach(data => {
            
            if(!data){

                formv = formv&&false
                if(count === 0){
                    message.error({
                        content: 'Empty Fields In LEAVE NORM DETAILS Tab!!!',
                        className: 'custom-class',
                        style: {
                            marginTop: '1vh',
                        },
                    });
                }

                count = count + 1;
            }
        })
        
        if(formv){

            console.log("Submitting");
           
            const postData = {
              "header": allData.header.rows,
              "details": allData.details.rows,
            }

            const postDataS = {
                "header": storeData.header.rows,
                "details": storeData.details.rows,
            }
            
            postData.details.forEach((lang,index) => {

                if(!lang.norms_hdr_code){
                    postData.details[index] = {
                        ...lang,
                        PARAM: "INSERT"
                    }
                }
    
                else{
                    postData.details[index] = {
                        ...lang,
                        PARAM: "UPDATE"
                    } 
                }
            })
    
            postDataS.details.forEach((lang,index) => {
                const dataIndex = postData.details.findIndex(element => element.norms_det_code === lang.norms_det_code)
                if(dataIndex === -1){
                    postData.details.push({
                        norms_det_code: lang.norms_det_code,
                        PARAM: "DELETE"
                    })
                }
            })
            
            console.log(JSON.stringify(postData, undefined, 2));
            setLoading(true)
            axios
              .patch(employeeData.URL + '/api/v1/norms/leave-norms/' + postData.header[0]['norms_hdr_code'], postData,  {
                  withCredentials: true,
                  credentials: 'include',
              })
              .then((response) => {
                  message.success({
                      content: 'Leave Norm Updated Successfully!!!',
                      className: 'custom-class',
                      style: {
                          marginTop: '2vh',
                      },
                  });
                  setLoading(false)
                  history('/payroll/norms/leave-norms')
              })
              .catch((err) => {
                  message.error({
                      content: 'An Error Occurred!!!!',
                      className: 'custom-class',
                      style: {
                          marginTop: '2vh',
                      },
                  });
                  setLoading(false)
              });
          }
    }

    const handleCancel = (event) => {

        setLoading(false)
        history('/payroll/norms/leave-norms')
    }

    return(
        allData && storeData && ad
        ?
        <Row className = {classes['RowP']}>
            <Col lg = {editMode ? 13 : 19} md = {editMode ? 13 : 19} className = {classes['Col']} >

            </Col>
            {
                editMode
                ?
                <>
                   <Col md = {4} >
                        {
                          loading
                          ?
                          <SyncLoader color = {"rgba(255,163,77,0.8)"} size = {10}/>
                          :
                           <button
                                                                       style={{
                                                                         padding: "7px 30px 14px 24px",
                                                                         borderRadius: "50px",
                                                                         background: "transparent",
                                                                         width: "100%",
                                                                         border: "none",
                                                                         outline: "none",
                                                                         fontSize: "16px",
                                                                         fontWeight: "600",
                                                                         lineHeight: "1.5",
                                                                         color: "#071e54",
                                                                         WebkitAppearance: "none",
                                                   
                                                                         boxShadow:
                                                                           "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                                                                         height: "40px",
                                                   
                                                                         // Ensure the button takes full width
                                                                       }}
                                                                       onClick={(event) => handleSave(event)}
                                                                       className={classes["ProfileButtonn"]}
                                                                       id="save"
                                                                       onMouseOver={(event) => {
                                                                         event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                                                                       }}
                                                                       onMouseOut={(event) => {
                                                                         event.target.style.boxShadow =
                                                                           "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                                                                       }}
                                                                     >
                                                                       Save
                           </button>
                        }
                        
                    </Col>
                    <Col md = {4} >
                        {
                          loading
                          ?
                          <SyncLoader color = {"rgba(255,163,77,0.8)"} size = {10}/>
                          :
                           <button
                                             style={{
                                               padding: "7px 30px 14px 24px",
                                               borderRadius: "50px",
                                               background: "transparent",
                                               width: "100%",
                                               border: "none",
                                               outline: "none",
                                               fontSize: "16px",
                                               fontWeight: "600",
                                               lineHeight: "1.5",
                                               color: "#071e54",
                                               WebkitAppearance: "none",
                         
                                               boxShadow:
                                                 "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                                               height: "40px",
                         
                                               // Ensure the button takes full width
                                             }}
                                             onClick={(event) => handleCancel(event)}
                                             onMouseOver={(event) => {
                                               event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                                             }}
                                             onMouseOut={(event) => {
                                               event.target.style.boxShadow =
                                                 "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                                             }}
                                             className={classes["ProfileButtonn"]}
                                           >
                                             Cancel
                           </button>
                        }
                    </Col>
                </>
                :
                <Col md = {4} >
                    <button onClick = {() => setEditMode(true)} className = {classes['ProfileButton']}>Edit Details</button>
                </Col>
            }
            <Col lg = {1} md = {1} >

            </Col>
            <Col lg = {24} md = {24} className = {classes['Col']}>
                <p></p>
                <div className = {classes['EditView']}>
                    <Tabs defaultActiveKey="0" centered style = {{ height: "100%"}} tabPosition={"left"} type = "line" >
                        <TabPane tab= {<span>Basic Details</span>} key="0">
                            <BasicLeaveDetails create = {false} ad = {ad} setData = {setAllData} data = {allData.header.rows[0]} editMode = {editMode} />
                        </TabPane>
                        <TabPane tab= {<span>Leave Norm Details</span>} key="1">
                            <p></p>
                            <LeaveNormDetails ad = {ad} editMode = {editMode}  setData = {setAllData} data = {allData.details.rows}/>
                        </TabPane>
                    </Tabs>
                </div>
            </Col>       
        
        </Row>
        :
        <>
            <Skeleton active = {true} />
            <Skeleton active = {true} />
            <Skeleton active = {true} />
            <Skeleton active = {true} />
        </>
    );
}

export default LeaveNormsView